<template>
    <div class="admin-setting-wraper">
            <div class="d-flex py-5 align-center">
                <p class="ma-0 text-h5 mr-5"><strong>Settings</strong></p>
            </div>
          <v-card class="mt-0">
            <v-card-title class="d-flex justify-lg-space-between">
                <div class="text-h6">
                    <strong>Template</strong>
                </div>
                <!-- <v-btn rounded small color="secondary" @click="show_editor = true">
                    <v-icon size="12" class="mr-1">mdi-plus-circle</v-icon>New
                </v-btn> -->
            </v-card-title>
            <hr class="mx-2"/>
            <v-card-text>
                <div>
                    <v-data-table
                        :loading="loading_table"
                        :headers="headers"
                        :items="datas.data"
                        :page.sync="page"
                        :items-per-page="10"
                        hide-default-footer
                        class="elevation-1"
                        @page-count="pageCount = $event"
                    >
                    <template v-slot:item.id="{ item, index }">
                        {{ index + 1 }}
                    </template>
                    <template v-slot:item.created_at="{ item, index }">
                        {{ formattedDate(item.created_at) }}
                    </template>
                    <template v-slot:item.company="{ item, index }">
                        {{item.company.name}}
                    </template>
                    <template v-slot:item.number_requests="{ item, index }">
                       <v-chip color="primary" class="text-white"> {{item.request.length}}</v-chip>
                    </template>

    
                    <template v-slot:item.action="{ item }">
                        <v-btn icon @click="handleEditTemplate($event,item)">
                            <v-icon size="20">mdi-pencil-circle</v-icon>
                        </v-btn>
                        <!-- |
                        <v-btn icon @click="handleDeleteCompanyList($event,item)">
                            <v-icon size="20" color="red">mdi-delete-circle</v-icon>
                        </v-btn> -->
                    </template>
                                                            
                    
                    </v-data-table>
                </div>
                <div class="text-center mt-5 elevation-3 grey lighten-2">
                    <v-pagination
                        v-model="page"
                        @input="handlePageChange"
                        :length="datas.last_page"
                    ></v-pagination>
                </div>
            </v-card-text>
          </v-card>
          <QuilEditor
            :open_modal="show_editor" 
            :item_selected="row_selected" 
            @handleSaveTemplate="handleSaveTemplate" 
            @handleModalHide = "show_editor = false, row_selected=null"
            @handleCompanyAdded="show_editor = false, getTemplate()"
        />
    </div>
  </template>
  
  <script>
  import { changeFormat } from '@/utils/dateHelper';
  import { payment_status } from  '@/helpers/payment_status';
  import { insurance_status } from  '@/helpers/insurance_status';
  import QuilEditor from  '../modals/QuilEditor.vue';

  export default {
    components:{
        QuilEditor
    },
    data () {
      return {
        show_editor : false,
        logs_selected : [],
        row_selected : [],
        selected : [],
        dateFrom: null,
        dateTo: null,
        menuFrom: false,
        menuTo: false,
        loading_table : false,
        user : this.$store.getters.user.user,
        search:null,
        showeducationmodal:false,
        showeligibilitymodal:false,
        payment_status:payment_status,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        headers: [
          { text: 'Title', value: 'title' },
          { text: 'Created at', value: 'created_at' },
          { text: 'Action', value: 'action' },

        ],
        datas:[],                             
        companies:[],
        query:{
          company : null,
          payment_status : null,
        },
      }
    },
  
    mounted(){
      this.getTemplate();
    },
  
    methods:{
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },

        formattedDate(date) {
          return changeFormat(date); // Example format string
        },

        handleEditTemplate(event, item){
          this.row_selected = item
          this.show_editor = true
        },


        handleDeleteCompanyList(event, item){
            event.stopPropagation();
            if(item.request.length){
                return this.$notiflix.Report.failure(
                    'Warning',
                    '<h5>You can’t delete this billing because it is currently in use.</h5>',
                    'Okay',
                );
            }
            else{
                this.$notiflix.Confirm.show(
                    'Delete',
                    'Are you sure, you want to delete this billing?',
                    'Yes',
                    'No',
                    () => {
                        this.deleteCompany(item)
                    },
                );
            }
        },

        handleGetPaymentStatus(id) {
         const status_payment = payment_status.find(item=>item.value == id);
         return status_payment.text
        },
        handlePageChange() {
        //   this.getBillingLogs()
        },
        handleShowLogs(item) {
          this.logs_selected = item;
          this.mail_logs_modal = true;
        },
        handleGetInsuranceStatus(id) {
         const status = insurance_status.find(item=>item.value == id);
         return status.text
        },
        handleSaveTemplate(datas) {
            this.$notiflix.Loading.arrows();
            this.axios.post(`/template`,datas).then((res)=>{
               this.$awn.success(`${datas.id ? 'Updated' : 'Added'} Successfully`)
                this.getTemplate()
                this.show_editor = false;
            }).catch((err)=>{
                console.log(err,'err')
            }).finally(()=>{
                this.$notiflix.Loading.remove();
            })
        },
        goTo(id){
            this.$router.push(`/application/${id}`)
        },
        goToSumarry(item){
            this.$router.push(`/billing/${item.user.client_company.company_id}/${item.billing_id}`)
        },
        getTemplate(){
            this.$notiflix.Loading.arrows();
            this.axios.get(`/template`).then((res)=>{
                this.datas = res.data.data
            }).catch((err)=>{
                console.log(err,'err')
            }).finally(()=>{
                this.$notiflix.Loading.remove();
            })
        },
    },
    // watch: {
    //   dateFromPicker (val) {
    //     this.dateFrom = this.formatDate(this.dateFromPicker)
    //   },
    // },

  }
  </script>
  
  <style lang="scss" scoped>
    .admin-setting-wraper{
        background-color: #ebebeb;;
        height: 100%;
        padding: 0 15px;

        .v-card{
            border-radius: 5px;
        }
    }
  </style>